import type { AxiosInstance } from 'axios';
import type { AxiosResponse } from 'axios';
import type {
  Asset,
  AssetListResponse,
  EntityId,
} from '@/types';

export const getPlotMarkerAsset = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  marker_id: EntityId,
  asset_id: EntityId,
): Promise<Asset> => {
  const resp = await api.get<Asset>(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker/${marker_id}/asset/${asset_id}`,
  );
  return resp.data;
};

export const getPlotMarkerAssetBinary = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  marker_id: EntityId,
  asset_id: EntityId,
): Promise<AxiosResponse<Blob>> => {
  const resp = await api.get<Blob>(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker/${marker_id}/asset/${asset_id}`,
    {
      responseType: 'blob',
    },
  );
  return resp;
};

export const getPlotMarkerAssets = async (
  api: AxiosInstance,
  plot_id: EntityId,
  waypoint_id: EntityId,
  marker_id: EntityId,
): Promise<AssetListResponse> => {
  const resp = await api.get<AssetListResponse>(
    `/plot/${plot_id}/waypoint/${waypoint_id}/marker/${marker_id}/asset`,
  );
  return resp.data;
};

